<template>
  <div class="container">
    <div id="app">
      <div style="flex: 1">
        <div class="header">
          <div style="width: 80%; margin: auto">
            <div class="flex-between head">
              <div class="flex head-box">
                <img class="logo" src="@/assets/index/logo.png" />
                <img class="logo" src="@/assets/index/logo2.png" />
              </div>
              <div class="flex search-box">
                <div class="flex search">
                  <input v-model="searchValue" />
                  <div class="btn">搜索</div>
                </div>
                <div class="flex user" v-if="isLogin && userInfo">
                  <el-tooltip
                    :content="`欢迎光临，${
                      (this.userInfo.user && this.userInfo.user.userName) ||
                      '用户'
                    }`"
                    placement="bottom"
                    effect="light"
                  >
                    <div class="user-name hidden1">
                      欢迎光临，{{ userName }}
                    </div>
                    <!-- 【{{userInfo.memberType || '会员'}}】 -->
                  </el-tooltip>
                  <div class="button font14 left-btn" @click="toPersonalCenter">
                    <i class="el-icon-user-solid"></i>
                    个人中心
                  </div>
                  <div class="button font14 left-btn" @click="toCart">
                    <!-- <i class="el-icon-user-solid"></i> -->
                    课程表
                  </div>
                  <div class="button loginOut" @click="toLogout">退出登录</div>
                </div>
                <div class="flex" v-else>
                  <div class="button left-btn" @click="register">注册</div>
                  <div class="button" @click="login">登录</div>
                </div>
              </div>
            </div>
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <el-tab-pane
                :label="item.name"
                :name="item.name"
                v-for="item in menu"
                :key="item.name"
              ></el-tab-pane>
            </el-tabs>
          </div>
        </div>
        <div class="banner" v-if="!isCenter">
          <el-carousel height="400px">
            <el-carousel-item v-for="(item, index) in banner" :key="index">
              <el-image
                style="width: 100%; height: 100%"
                :src="item.url"
                fit="cover"
              ></el-image>
            </el-carousel-item>
          </el-carousel>
        </div>
        <router-view></router-view>
      </div>
      <div class="foot">
        <div>
          <div>联系地址：攀枝花市东区炳草岗中心广场阳光大梯道1号</div>
          <div>联系电话：0812-2223536</div>
          <div>联系邮箱：936997327@qq.com</div>
          <div>
            <span> 网站备案：</span>
            <a href="https://beian.miit.gov.cn/" target="_blank">
              蜀ICP备2025171672号-2
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import { secrecyMobile } from "@/utils/util";
import { getUserInfo, clearUserInfo, isLoggedIn } from "@/utils/auth";
import { findRoute } from "@/utils/routerHelper.js";
import { logout, queryForm } from "@/api/api.js";

export default {
  name: "app",
  components: {},
  data() {
    return {
      searchValue: "",
      activeName: "首页",
      menu: [
        {
          name: "首页",
          path: "/index",
        },
        {
          name: "关于我们",
          path: "/aboutUs",
        },
        {
          name: "协会资讯",
          path: "/associationNews",
        },
        {
          name: "会员中心",
          path: "/memberCenter",
        },
        {
          name: "会员服务",
          path: "/memberService",
        },
        {
          name: "专题专栏",
          path: "/specialColumn",
        },
        {
          name: "资源中心",
          path: "/resourceCenter",
        },
        {
          name: "求助建议",
          path: "/adviceForHelp",
        },
      ],
      banner: [
        // {
        //     url:'https://smartserver-file.oss-cn-chengdu.aliyuncs.com/huaCheng/banner1.jpg'
        // },
        // {
        //     url:'https://smartserver-file.oss-cn-chengdu.aliyuncs.com/huaCheng/banner2.jpg'
        // }
      ],
      currentRouter: "/",
      userInfo: null,
      isLogin: false,
      isCenter: false,
    };
  },
  created() {
    this.checkLoginStatus();
    this.getBanner();
    if (sessionStorage.getItem("store")) {
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(sessionStorage.getItem("store"))
        )
      );
    }

    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem("store", JSON.stringify(this.$store.state));
    });

    window.addEventListener("loginStatusChanged", () => {
      this.updateLoginStatus();
    });
  },
  computed: {
    userName() {
      return secrecyMobile(
        (this.userInfo.user && this.userInfo.user.userName) || "用户"
      );
    },
  },
  watch: {
    $route: function (to) {
      this.currentRouter = to.path;
      this.isCenter = to.path.includes("personalCenter");
      let data = this.menu.find(
        (v) => this.currentRouter.includes(v.path) && !this.isCenter
      );
      this.activeName = data ? data.name : "";
    },
  },
  methods: {
    ...mapMutations("routerData", ["changeRouterList"]),
    getBanner() {
      queryForm({
        formKey: "ULcOIF0X",
        queryId: "283",
        queryParams: {
          workflowStatus: "通过",
        },
        size: 20,
        current: 0,
      }).then((res) => {
        if (res.data.code == 200) {
          this.banner = res.data.data.rows.map((v) => {
            v.url =
              v.image_upload1768892426437 && v.image_upload1768892426437[0]
                ? v.image_upload1768892426437[0].url
                : "";
            return v;
          });
        }
        console.log(res);
      });
    },
    checkLoginStatus() {
      this.isLogin = isLoggedIn();
      this.userInfo = getUserInfo();
    },
    updateLoginStatus() {
      this.isLogin = isLoggedIn();
      this.userInfo = getUserInfo();
    },
    toPersonalCenter() {
      if (this.$route.path == "/personalCenter/index") return;
      this.$router.push("/personalCenter");
    },
    toLogout() {
      this.$confirm("确定要退出登录吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          logout().then((res) => {
            if (res.data.code == 200) {
              clearUserInfo();
              this.updateLoginStatus();
              window.dispatchEvent(new Event("loginStatusChanged"));
              this.$message.success("退出登录成功");
              if (this.$route.name != "index") {
                this.$router.push("/");
              }
            } else {
              this.$message.error("退出登录失败");
            }
          });
        })
        .catch(() => {});
    },
    register() {
      this.changeRouterList([]);
      this.$router.push({
        path: "/register/agreement",
      });
      let routerList = this.$store.state.routerData.routerList;
      let data =
        this.$router.options.routes &&
        findRoute(this.$router.options.routes, "/register/agreement");
      if (data && data.meta) {
        let newData = routerList.find((v) => v.name == data.meta.name);
        if (!newData) {
          routerList.push(data);
          this.changeRouterList(routerList);
        }
      }
    },
    handleClick(tab) {
      let path = this.menu[Number(tab.index)].path;
      if (this.$route.path == path) {
        return;
      }
      this.$router.replace(path);
      this.changeRouterList([]);
    },
    login() {
      if (this.$route.path == "/login") return;
      this.$router.push({
        path: "/login",
      });
    },
    toCart() {
      if (this.$route.path == "/personalCenter/trainingSystem/cart") return;
      this.$router.push("/personalCenter/trainingSystem/cart");
    },
  },
};
</script>

<style  scoped lang="less">
#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.header {
  width: 100%;
  height: 144px;
  .head {
    padding: 24px 0 16px;
    .head-box {
      gap: 24px;
    }
    .logo {
      width: auto;
      height: 52px;
      object-fit: cover;
    }
    .search {
      width: 240px;
      height: 33px;
      border: 1px solid #e4e4e4;
      border-radius: 8px;
      overflow: hidden;
      margin-right: 24px;
      justify-content: flex-end;
      input {
        flex: 1;
        height: 33px;
        outline: none;
        border: none;
        padding: 12px;
      }
      .btn {
        padding: 0 12px;
        height: 100%;
        background: #ed9d26;
        font-size: 14px;
        color: #ffffff;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-shrink: 0;
      }
    }
    .button {
      padding: 0 10px;
      height: 33px;
      line-height: 33px;
      background: #ed9d26;
      border-radius: 7px;
      font-size: 18px;
      color: #ffffff;
      text-align: center;
      cursor: pointer;
    }
    .left-btn {
      margin-right: 12px;
    }
    .font14 {
      font-size: 14px;
    }

    .user {
      font-size: 16px;
      color: #333333;
      .user-name {
        max-width: 255px;
        margin-right: 24px;
      }
      .loginOut {
        background: #f0f0f0;
        font-size: 14px;
        color: #666666;
      }
    }
  }
}
.foot {
  height: 133px;
  background: #675c4e;
  font-size: 18px;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  div {
    line-height: 24px;
  }
}
a {
  color: #ffffff;
  text-decoration: none;
  margin-left: -5px;
}
// 导航条样式调整
// 去掉底部边框
::v-deep .el-tabs__nav-wrap::after {
  height: 0;
}
// 调整块
::v-deep .el-tabs__item {
  font-size: 24px;
  font-weight: bold;
  padding: 0 48px;
  height: 48px;
  margin: 0 auto;
}
::v-deep .el-tabs__item.is-active,
::v-deep .el-tabs__item:hover {
  color: #ed9d26;
}
::v-deep .el-tabs__active-bar {
  height: 6px;
  background: #ed9d26;
  border-radius: 8px 8px 0px 0px;
  margin-top: 8px;
}
::v-deep .el-tabs__nav {
  width: 100%;
}
::v-deep .el-tabs__item.is-top:nth-child(2) {
  padding-left: 72px !important;
}

// 轮播图样式调整
::v-deep .banner .el-carousel__button {
  width: 10px;
  height: 10px;
  background: rgba(255, 255, 255, 0.5);
  border-radius: 50%;
}
::v-deep .banner .el-carousel__indicator.is-active button {
  width: 12px;
  height: 12px;
  border: 2.08px solid #ffffff;
  background: #ffffff;
  border-radius: 50%;
}
::v-deep .banner .el-carousel__indicators {
  display: flex;
  align-items: center;
  height: 36px;
}
::v-deep .banner .el-carousel__indicator--horizontal {
  padding: 0 4px;
}
::v-deep .el-tabs__item:focus.is-active.is-focus:not(:active) {
  box-shadow: none;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
}
</style>
